import React from 'react';
import { Loader2 } from 'lucide-react';

export const Spinner = ({ size = 'md', className = '' }) => {
    const sizes = {
        sm: 'w-4 h-4',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
    };
    return <Loader2 className={`animate-spin ${sizes[size]} ${className}`} />;
};

/**
 * Full-screen spinner used by lazy-route Suspense and ShareableLinkPage fetch.
 * Keeps the same stack (spinner + subtitle row) so the icon does not shift when the chunk loads.
 */
export function FullScreenRouteSpinner({ subtitle }) {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="text-center">
                <Spinner size="lg" className="text-blue-500 mx-auto block" />
                {subtitle ? (
                    <p className="mt-4 text-gray-600">{subtitle}</p>
                ) : (
                    <div className="mt-4 min-h-6" aria-hidden />
                )}
            </div>
        </div>
    );
}

const LoadingSpinner = () => {
    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="flex flex-col items-center gap-4">
                <Spinner size="lg" className="text-blue-600" />
                <p className="text-gray-500 text-sm">Loading...</p>
            </div>
        </div>
    );
};

export default LoadingSpinner;
